export class DataImport {
    thingId: string;
    dateTime: number;
    state;
    creationTimestamp: number;
    lastUpdateTimestamp: number;
}

export enum DataImportState {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}